import './session/sessiontimer';
import { bindToggles } from './rootcomponents/toggle';
import './rootcomponents/printable';
import './rootcomponents/character-counter';
import './rootcomponents/symbol-conversion';
import './rootcomponents/client-validation';
import './rootcomponents/file-upload';
import './rootcomponents/read-more';
import './rootcomponents/combobox';
import './rootcomponents/pdf-viewer';
import { initSession, showTalentNetworksIfAvailable } from './session/sessionmain';
import { bindAutocompletes } from './rootcomponents/autocomplete';
import { updateSessionUI } from './session/sessionui';
import { dismissElement } from './rootcomponents/toggle';
import './rootcomponents/alert-banner';
import './rootcomponents/offcanvas';
import './rootcomponents/memorable-date';
import htmx from 'htmx.org';
import { prepareAuthenticationAttribution } from './attribution';

declare global {
    interface Window {
        htmx: typeof htmx;
    }
}

window.htmx = htmx;

document.addEventListener('DOMContentLoaded', async () => {
    await Promise.race([
        prepareAuthenticationAttribution().catch(error => console.debug('Unable to capture authentication attribution.', error)),
        new Promise<void>(resolve => setTimeout(resolve, 1000))
    ]);
    initSession()
        .then(() => {
            updateSessionUI();
            bindToggles();
            bindAutocompletes();
            bindEvents();
            showTalentNetworksIfAvailable();
        });
    setBackToTopVisibility();
});

htmx.onLoad(() => {
    bindToggles();
    bindAutocompletes();
});

function bindEvents() {
    window.addEventListener('resize', setSiteNavMenuState);
    document.querySelector<HTMLElement>('#footer-back-to-top')?.addEventListener('click', backToTopClicked);
    document.addEventListener('acclick', autocompleteClicked);
}

function setBackToTopVisibility() {
    const backToTopButton = document.querySelector<HTMLElement>('#footer-back-to-top');
    if (!backToTopButton) {
        return;
    }

    if (backToTopButton.hasAttribute('hidden') && document.documentElement.scrollHeight > window.innerHeight) {
        backToTopButton.attributes.removeNamedItem('hidden');
    }
    else {
        backToTopButton.setAttribute('hidden', 'true');
    }
}

function setSiteNavMenuState() {
    setBackToTopVisibility();
    const siteNavMenu = document.querySelector<HTMLElement>('#site-nav-menu');
    const siteNavOverlay = document.querySelector<HTMLElement>('#site-nav-overlay');

    if (siteNavMenu === null) {
        return;
    }

    if (window.innerWidth >= 768 && siteNavMenu.getAttribute('data-expanded') === "true") {
        dismissElement(siteNavMenu);
        if (siteNavOverlay !== null) {
            dismissElement(siteNavOverlay);
        }
    }
}

function backToTopClicked(evt: Event) {
    window.scrollTo(0, 0);
    document.querySelector<HTMLElement>('#skip-to-main')?.focus();
}

function autocompleteClicked() {
    localStorage.setItem('autocomplete', 'true');
}
